import store from '../store';
export const SET_POPUP = 'SET_POPUP_POPUP';
/*
	data = {entry.name}:{entry.value}{entry.aftertext ? entry.aftertext : ''}
*/
export const setPopup = (data, title) => {
  return {
    type: SET_POPUP,
    data: data,
    title: title
  }
}

//for easier calling from old OL modules
export const showPopup = (data, title) => {
	
	return store.dispatch(setPopup(data, title));
}	


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/popup/actions.js